

<script>
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import moment from 'moment';
import { icons } from "../data-fontawesome";
import {
  urlMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "Đơn hàng",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner
  },
  data() {
    return {
      title: "Đơn hàng",
      icons: icons,
      totalRows: 0,
      currentPage: 1,
      orderfilterOn: [],
      orders: [],
      orderFilter: null,
      startDate: '01'+moment().format("/MM/YYYY"),
      endDate: moment().format("DD/MM/YYYY"),
      isLoading: false,
      dateRange: [
        new Date(moment().format("YYYY-MM-")+'01'), new Date()
      ],
      statusSelected: [{id: "all", name: 'Tất cả trạng thái'}],
      posSelected: [{id: "all", name: 'Tất cả điểm bán lẻ'}],
      optionStatus: [
        {id: "all", name: 'Tất cả trạng thái'},
        {id: "new", name: 'Mới'},
        {id: "running", name: 'Đang xử lý'},
        {id: "error", name: 'Lỗi đồng bộ'},
        {id: "success", name: 'Hoàn thành'},
        {id: "cancel", name: 'Đã huỷ'}
      ],
      optionPos: [],
      loadingArr: [],
      searchText: "",
      fields: [
        "id",
        {
          key: "name",
          label: "Mã đơn hàng"
        },
        {
          key: "customer_name",
          label: "Khách hàng"
        },
        {
          key: "created_at",
          label: "Ngày mua"
        },
        {
          key: "pos_name",
          label: "Điểm bán lẻ"
        },
        {
          key: "sale_man_name",
          label: "NVBH"
        },
        {
          key: "amount_total",
          label: "Tổng",
          formatter: value => {
            if(typeof value == 'undefined' || value == null) return 0;
            return value.toLocaleString() + ' ₫';
          }
        },
        {
          key: "birthdate",
          label: "Ngày sinh KH"
        },
        {
          key: "status",
          label: "Trạng thái"
        },
        {
          key: "action",
          label: "#"
        }
      ]
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem('currentUser') || false;
      return user ? JSON.parse(user) : false;
    },
    windowWidth(){
      return window.innerWidth;
    }
  },
  methods: {
    ...urlMethods,
    changeTimeRange(){
      let that = this;      
      that.startDate = moment(that.dateRange[0]).format('DD/MM/YYYY');
      that.endDate = moment(that.dateRange[1]).format('DD/MM/YYYY');
      that.currentPage = 1;
      that.getOrders();
    },
    searchOrder(){
      let that = this;
      that.currentPage = 1;
      that.getOrders();
      },
    changeStatus(){
      let that = this;
      that.currentPage = 1;
      that.getOrders();
    },
    changePos(){
      this.getOrders();
    },
    changePage(){
      let that = this;
      that.getOrders();
    },
    getPosList(){
      let that = this;
      that.isLoading = true;
      setTimeout(async () => {
         try {
          let res = await that.getUrl('pos-list');
          that.optionPos = res.data;
        } catch (error) {
          let text = (typeof error  == 'string' ? error : JSON.stringify(error));that.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
        }
        that.getOrders();
      }, 50);
    },
    async getOrderStep2(){
      let that = this;
      let statusFilter = [];
      let posFilter = [];
      for(const stt of that.statusSelected){
        if(stt.id == 'all') statusFilter = ['all'];
        else if(!statusFilter.includes('all')){
          statusFilter.push(stt.id)
        }else{}
      }
      for(const pos of that.posSelected){
        if(pos.id == 'all') posFilter = ['all'];
        else if(!posFilter.includes('all')){
          posFilter.push(pos.id)
        }else{}
      }
      let body = {
        start: that.startDate, end: that.endDate, s: that.searchText,
        status: statusFilter, page: that.currentPage, posID: that.currentUser.pos_id,
        pos: posFilter
      };
      try {
        let res = await that.postUrl({'url' : 'orders', 'data' : body});
        that.orders = res.data;
        that.totalRows = res.total;that.isLoading = false;
      } catch (error) {
        that.orders = [];
        that.totalRows = 0;
      that.isLoading = false;
        let text = (typeof error  == 'string' ? error : JSON.stringify(error));this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
      }
    },
    removeLoading(_id = 0){
      let that = this;
      that.loadingArr = that.loadingArr.filter(function(item){return item != _id;});
    },
    loadingOrder(id = 0){
      let that = this;
      return that.loadingArr.includes(id);
    },
    async syncOrder(id = 0){
      let that = this;
      Swal.fire({
        title: 'Bạn có chắc chắn?',
        showCancelButton: true,
        confirmButtonText: 'Đồng bộ ngay',
        cancelButtonText: 'Không. Bỏ qua'
      }).then(async (result) => {
        if (result.isConfirmed) {
          that.loadingArr.push(id);
          setTimeout(async () => {
                 
          try {
            let res = await that.postUrl({'url' : 'sync-order', 'data' : {'id':id, 'posID' : that.currentUser.pos_id}});
            if(typeof res.error != 'undefined' && res.error){
                throw res.message;
            }
            that.removeLoading(id);
          } catch (error) {
            that.removeLoading(id);
            let text = (typeof error  == 'string' ? error : JSON.stringify(error));this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
          }
            that.getOrders();
          }, 100);
        } else if (result.isDenied) {
          that.removeLoading(id);
        }
      })
    },
    async cancelOrder(id = 0){
      let that = this;
      Swal.fire({
        title: 'Thao tác huỷ đơn không thể khôi phục. Bạn có chắc chắn?',
        showCancelButton: true,
        confirmButtonText: 'Huỷ đơn',
        cancelButtonText: 'Không. Bỏ qua'
      }).then(async (result) => {
        if (result.isConfirmed) {
          that.loadingArr.push(id); 
          setTimeout(async () => {
                     
          try {
            let res = await that.postUrl({'url' : 'cancel-order', 'data' : {'id':id, 'posID' : that.currentUser.pos_id}});
            if(typeof res.error != 'undefined' && res.error){
                throw res.message;
            }
            that.removeLoading(id);
          } catch (error) {
            that.removeLoading(id);
            let text = (typeof error  == 'string' ? error : JSON.stringify(error));this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
          }
            that.getOrders();
          }, 100);
        } else if (result.isDenied) {
          that.removeLoading(id);
        }
      })
    },
    async getOrders(){
      let that = this;
      that.isLoading = true;
      setTimeout(async () => {
        await that.getOrderStep2()
      }, 0);
    },
  },
  mounted() {
    if(this.currentUser.role == 1){
      this.getPosList();
    }else{
      this.getOrders();
    }
  },
};
</script>

<template>
  <Layout>
    <div class="page-header">
      <div class="page-title">
        <h4 class="mb-0 font-size-18">Đơn hàng</h4>
      </div>
      <router-link to="/sale">
        <b-button variant="primary">Mở POS bán hàng</b-button>
      </router-link>
    </div>
    <div class="card">
      <div class="card-body pb-0">
        <div class="filter-box">
          <div class="filter-item">
            <div class="search-box me-2 mb-0 d-inline-block">
              <div class="position-relative">
                <input type="text" class="form-control" v-model="searchText" v-on:keyup.enter="searchOrder" placeholder="Tìm kiếm theo mã đơn hàng, SĐT, serial..." />
                <i class="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div class="filter-item filter-daterange">
            <date-picker v-model="dateRange" range append-to-body lang="vn" confirm @change="changeTimeRange"></date-picker>
          </div>
          <div class="filter-item" style="min-width: 170px;">
            <multiselect :show-labels="false" v-model="statusSelected" label="name" track-by="id" placeholder="Trạng thái" @change="changeStatus" @input="changeStatus" @select="changeStatus" :options="optionStatus" :multiple="true"></multiselect>
          </div>
          <div class="filter-item" style="min-width: 170px;" v-if="optionPos.length > 1">
            <multiselect :show-labels="false" v-model="posSelected" label="name" track-by="id" placeholder="Trạng thái" @change="changePos" @input="changePos" @select="changePos" :options="optionPos" :multiple="true"></multiselect>
          </div>
          <div class="filter-item" style="display:flex;align-items:center;justify-content:center;flex-direction:column;"><i :class="(!isLoading ? ' hiden' : '')" style="line-height: 1" class="fas fa-spinner fa-spin font-size-18"></i></div>
          <div class="filter-item filter-end"></div>
        </div>
        <div class="table-responsive" style="padding: 0px 0px 15px" v-if="orders.length > 0">
          <b-table id="my-table" class="p-0 m-0 table-striped table-bordered" striped hover :items="orders" :fields="fields">
            <template v-slot:cell(name)="data">
              <router-link :to="`/order/${data.item.id}`">{{ data.item.name }}</router-link>            </template>
            <template v-slot:cell(status)="data">
              <span :class="'badge font-size-12 bg-'+data.item.status_class">{{ data.item.status_name }}</span>
            </template>
            <template v-slot:cell(customer_name)="data">{{ data.item.customer_name }} - {{ data.item.customer_phone }}</template>
            <template v-slot:cell(action)="data">
            <b-button variant="primary" @click="syncOrder(data.item.id)" size="sm" v-if="data.item.status == 'new' || data.item.status == 'error'">
              <i :class="'bx bx-transfer-alt align-middle ' + (loadingOrder(data.item.id) ? 'hiden' : '')"></i>
              <i :class="'fas fa-spinner fa-spin ' + (loadingOrder(data.item.id) ? '' : 'hiden')"></i> Đồng bộ ngay
            </b-button>
            <b-button style="margin-left: 3px;" variant="danger" @click="cancelOrder(data.item.id)" size="sm" v-if="data.item.status == 'error'"><i v-if="!loadingOrder(data.item.id)" class="bx bx-x align-middle"></i><i  v-if="loadingOrder(data.item.id)" class="fas fa-spinner fa-spin"></i> Huỷ đơn</b-button>
            </template>
          </b-table>
        </div>
        <div class="row" style="padding-bottom: 15px;" v-if="totalRows > 50">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination  aria-controls="my-table" @change="changePage" v-model="currentPage" :total-rows="totalRows" :per-page="50"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
